import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';

import { suggestModalReducerKey } from './SuggestModalConstants';
import {
  isLoading as isLoadingSelector,
  currentDB as currentDBSelector,
  opModel as opModelSelector,
  expandedValue as expandedValueSelector,
  highlightedItem as highlightedItemSelector,
  fullUpdate as fullUpdateSelector,
  currentPage as currentPageSelector,
  noData as noDataSelector,
  maxPage as maxPageSelector,
} from './SuggestModalSelectors';

import {
  applyChanges,
  clearSelected,
  init,
  pushToSelected,
  searchByKeyword,
  selectDatabase,
  selectPage,
  closeSuggestModal,
  loadNexPage,
} from './SuggestModalActions';
import suggestModalReducer from './SuggestModalReducer';
import SuggestModal from './SuggestModal';

const mapStateToProps = (state) => ({
  isLoading: isLoadingSelector(state),
  database: currentDBSelector(state),
  opModel: opModelSelector(state),
  expandedValue: expandedValueSelector(state),
  highlightedItem: highlightedItemSelector(state),
  fullUpdate: fullUpdateSelector(state),
  currentPage: currentPageSelector(state),
  noData: noDataSelector(state),
  maxPage: maxPageSelector(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  init: () => dispatch(init(ownProps)),
  close: () => dispatch(closeSuggestModal()),
  selectDatabase: (database) => dispatch(selectDatabase(database)),
  clearSelected: () => dispatch(clearSelected()),
  applyChanges: () => dispatch(applyChanges(ownProps.closeCallback)),
  selectPage: (pageNumber) => dispatch(selectPage(pageNumber)),
  pushToSelected: (item) => dispatch(pushToSelected(item)),
  searchByKeyword: (keyword) => dispatch(searchByKeyword(keyword)),
  loadNextPage: (pageNumber, loadConfig, skipLoad) => dispatch(loadNexPage(pageNumber, loadConfig, skipLoad)),
});

export default compose(
  withReducer(suggestModalReducerKey, suggestModalReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(SuggestModal);
